import { axiosInstance } from "../axios_Instanse";
import { axiosInstance_modal } from "../axios_instance_modal";
import {
  getSubOrders,
  setQrCode,
  set_Qr_Loading,
  set_Load_Download,
} from "./OrderActionCreators";
import Store from "../Store";
import fileDownload from "js-file-download";
import {
  popupMessagesHandler,
  set_Let_Refresh,
} from "../General/generalActionCreators";
import { convertShamsiToDate } from "../General/generalActions";

export const getSubOrder = async (id) => {
  try {
    Store.dispatch(getSubOrders([]));
    const subOrder = await axiosInstance_modal.get(`/details/${id}`);
    Store.dispatch(getSubOrders(subOrder.data));
  } catch (error) {}
};
export const getOrdersWithState = async (state) => {
  try {
    const { data } = await axiosInstance_modal.post(`/orders/${state}`);
    return data;
  } catch (error) {}
};

export const downloadAllOrderDetails = async (orderId, rowValue) => {
  Store.dispatch(
    set_Load_Download({
      all: true,
      single: false,
    })
  );
  Store.dispatch(set_Let_Refresh(true));
  try {
    const file = await axiosInstance_modal.get(`/files/${orderId}`, {
      responseType: "blob",
    });

    Store.dispatch(
      set_Load_Download({
        all: false,
        single: false,
      })
    );

    fileDownload(file.data, `${rowValue} : سفارش شماره .zip`);
    return true;
  } catch (error) {}
};
export const downloadSingleOrderFile = async (
  orderId,
  fileId,
  fileName,
  rowValue
) => {
  Store.dispatch(set_Let_Refresh(true));
  Store.dispatch(
    set_Load_Download({
      all: false,
      single: true,
    })
  );
  try {
    const singlefile = await axiosInstance_modal.get(
      `/files/${orderId}/${fileId}`,
      { responseType: "blob" }
    );
    Store.dispatch(
      set_Load_Download({
        all: false,
        single: false,
      })
    );

    fileDownload(singlefile.data, `${rowValue}-${fileName}`);
  } catch (error) {}
};

export const changeActiveOrdersState = async (orderStateToChange) => {
  // const { refresh } = Store.getState().OrderReducer;
  try {
    Store.dispatch(set_Qr_Loading(true));
    Store.dispatch(setQrCode(null));
    const qrData = await axiosInstance_modal.get(
      `/barcode/${orderStateToChange}`
    );
    // Store.dispatch(set_Refresh(refresh + 1));
    Store.dispatch(set_Qr_Loading(false));
    Store.dispatch(setQrCode(qrData.data));
  } catch (error) {}
};

export const getActive_Ready_Orders = async () => {
  try {
    const Orders = await axiosInstance.get("/publisher_current_orders");
    const activeOrders = Orders.data.active
      .sort((a, b) => {
        // Orders.data.active
        if (a?.immediate_delivery) return -1;
        if (b?.cDate > a?.cDate) return 1;
        return -1;
      })
      .map((order) => ({
        ...order,
        converted_cdate: convertShamsiToDate(order.order_date),
      }));
    // Orders.data.ready_to_send
    const ReadyOrders = Orders.data.ready_to_send.sort((a, b) => {
      if (a?.immediate_delivery) return -1;
      if (b?.cDate > a?.cDate) return 1;
      return -1;
    });
    // Orders.data.ready_to_send
    const RejectedOrders = Orders?.data?.not_delivered?.sort((a, b) => {
      if (a?.immediate_delivery) return -1;
      if (b?.cDate > a?.cDate) return 1;
      return -1;
    });

    return { activeOrders, ReadyOrders, RejectedOrders };
  } catch (error) {}
};

export const accept_reject_order = async ({ code, id }) => {
  try {
    const { data } = await axiosInstance.post(`/accept_rejected/${id}`, {
      reject_code: code,
    });
    Store.dispatch(
      popupMessagesHandler({ mode: true, message: data, color: "success" })
    );
    return data;
  } catch (error) {}
};
